<div [style]="'--height: ' + height"
     class="empty ion-padding"
>
    @if (icon) {
        <ion-icon [name]="icon" />
    }
    <ng-content />
</div>
